import React from 'react';
import Configuration from './components/configuration/ConfigurationView';
import Preview from './components/preview/PreviewView';
import Main from './components/main/MainView';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './App.scss';
import { BrowserRouter as Router, Route, Switch, RouteComponentProps, Redirect } from 'react-router-dom';
import RestrictedRoute from './utils/RestrictedRoute';
import { Store as appStore } from './redux/reducers';
import store from './redux/store';
import { Store } from 'redux';
import Action from './redux/reducers/models/action';
import queryString from 'query-string';
import { SET_CULTURE, SET_COMPANY_ID, SET_COUNTRY, SET_ENTRY_POINT_URL } from './redux/actionTypes';
import { getEntryPointUrl } from './utils/helpers';
import { TransitionState } from './enums/transitionStates';
import { Subject } from 'rxjs';

const TransitionState$ = new Subject<TransitionState>();

export const TranstitonStateValue = TransitionState$.asObservable();

const checkConfigrationID = (store: Store<appStore>) => {
  return !!store.getState().vehicleOverviewState.Parts.length;
};

const renderMain = (props: RouteComponentProps) => {
  const parsed = queryString.parse(props.location.search);

  if ('culture' in parsed && 'id_company' in parsed && 'country' in parsed) {
    console.log(
      `saving setting for culture: ${parsed.culture}, company id: ${parsed.id_company}, and country: ${parsed.country} `
    );
    store.dispatch<Action>({ type: SET_CULTURE, payload: parsed.culture });
    store.dispatch<Action>({ type: SET_COMPANY_ID, payload: parsed.id_company });
    store.dispatch<Action>({ type: SET_COUNTRY, payload: parsed.country });

    console.log(`saving setting for entry point URL`);
    if (!getEntryPointUrl().length) {
      store.dispatch<Action>({ type: SET_ENTRY_POINT_URL, payload: window.location.href.replace('/main', '') });
    }
  }
  return <Main {...props}></Main>;
};

const renderRoot = (props: RouteComponentProps<any>) => {
  const search = props.location.search ? props.location.search : '';
  return <Redirect to={`/main/${search}`}></Redirect>;
};

export const loadOneTrust = () => {
  const existingScript = document.getElementById('onetrust');

  if (!existingScript) {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script.charset = 'UTF-8';

    script.setAttribute('data-document-language', 'true');
    script.setAttribute('data-domain-script', '4ceffab1-4567-4a2f-afd8-13c433741ab5');
    script.setAttribute('id', 'onetrust');

    document.head.appendChild(script);

    script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `function OptanonWrapper() { }`;
    document.head.appendChild(script);
  }
};

class App extends React.Component {
  componentDidMount() {
    loadOneTrust();
  }
  render() {
    return (
      <Router>
        <Route
          render={({ location }: RouteComponentProps<any>) => (
            <TransitionGroup className='full-height transition-group'>
              <CSSTransition
                key={location.key}
                classNames='fade'
                timeout={{ enter: 300, exit: 300 }}
                onEnter={() => {
                  TransitionState$.next(TransitionState.Enter);
                }}
                onExited={() => {
                  TransitionState$.next(TransitionState.Exit);
                }}
              >
                <section id='main-switch-wrapper' className='full-height'>
                  <Switch location={location}>
                    <Route exact path='/' render={renderRoot} />
                    <Route path='/main' render={renderMain} />
                    <RestrictedRoute
                      checkStore={checkConfigrationID}
                      hasParam='modelId'
                      path='/configuration/:modelId'
                      component={Configuration}
                    />
                    <Route path='/preview' component={Preview} />
                  </Switch>
                </section>
              </CSSTransition>
            </TransitionGroup>
          )}
        ></Route>
      </Router>
    );
  }
}

export default App;
